(function () {
    'use strict';

    angular
        .module('surveyCampaignControllers')
        .controller('NewCampaignController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'surveyCampaignService'];

    function Controller($scope, $state, topBarService, surveyCampaignService) {
        $scope.campaign = {};

        $scope.create = function () {
            surveyCampaignService
                .createCampaign($scope.campaign)
                .then(function () {
                    $state.go('survey.campaign', {}, { reload: true });
                })
        };

        topBarService.setTitleAndIcon('Campaign', 'fa fa-bullhorn');
    }
})();